module.exports = __webpack_public_path__ + "img/btn2.95756650.jpeg";